import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=27040525&scoped=true&"
var script = {}
import style0 from "./spinner.vue?vue&type=style&index=0&id=27040525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27040525",
  null
  
)

export default component.exports